module.exports = __webpack_public_path__ + "img/curve_line_2_icon.52e0e05f.svg";